// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ClientProvider } from './context/ClientContext'; // Importa el ClientProvider
import { ProgressProvider } from './context/ProgressContext';
import MobileLayout from './layouts/MobileLayout';
import MaintenanceScreen from './components/MaintenanceScreen';
import TestEnvironmentBanner from './components/TestEnvironmentBanner';

// Importa tus layouts y páginas
import AuthLayout from './layouts/AuthLayout';
import PortalLayout from './layouts/PortalLayout';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage'; // Importa ProfilePage
import ProtectedRoute from './components/ProtectedRoute';
import MobileProtectedRoute from './components/MobileProtectedRoute';
import SalesPage from './pages/SalesPage';
import DocumentsPage from './pages/DocumentsPage';
import MobileDocumentsPage from './pages/MobileDocumentsPage';
import ErrorPage from './pages/ErrorPage';
import MobileErrorPage from './pages/MobileErrorPage';
import MobileOnboardingPage from './pages/MobileOnboardingPage';
import CollectionPage from './pages/CollectionPage';
import ZReportsPage from './pages/ZReportsPage';
import SimulatorPage from './pages/SimulatorPage';
import MobileCustomerFlowPage from './pages/MobileCustomerFlowPage';

function App() {
  // Verificar si el modo de mantenimiento está activado
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const isTestEnvironment = process.env.REACT_APP_TEST_ENVIRONMENT === 'true';

  // Si está en modo mantenimiento, mostrar solo la pantalla de mantenimiento
  if (isMaintenanceMode) {
    return (
      <>
        {isTestEnvironment && <TestEnvironmentBanner />}
        <div className={isTestEnvironment ? 'app-with-test-environment-banner' : undefined}>
          <MaintenanceScreen />
        </div>
      </>
    );
  }

  return (
    <>
      {isTestEnvironment && <TestEnvironmentBanner />}
      <div className={isTestEnvironment ? 'app-with-test-environment-banner' : undefined}>
        <Router>
          <Routes>
            {/* Rutas de autenticación */}
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<LoginPage />} />
            </Route>

            {/* Rutas protegidas dentro del Portal */}
            <Route
              element={
                <ProtectedRoute>
                  <ClientProvider>
                    <ProgressProvider>
                      <PortalLayout />
                    </ProgressProvider>
                  </ClientProvider>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<HomePage />} />
              <Route path="/clientes/:dni" element={<ProfilePage />} />
              <Route path="/ventas" element={<SalesPage />} />
              <Route
                path="/simulador"
                element={
                  <ProtectedRoute type="simulator">
                    <SimulatorPage />
                  </ProtectedRoute>
                }
              />
              <Route 
                path="/cobros" 
                element={
                  <ProtectedRoute type="collections">
                    <CollectionPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/documentos" 
                element={
                  <ProtectedRoute type="documents">
                    <DocumentsPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/reportes-z" 
                element={
                  <ProtectedRoute type="zreports">
                    <ZReportsPage />
                  </ProtectedRoute>
                } 
              />
            </Route>

            {/* Rutas móviles sin layout completo */}
            <Route element={<MobileLayout />}>
              {/* Rutas públicas (sin token) */}
              <Route path="/m/error/:type" element={<MobileErrorPage />} />
              
              {/* Rutas protegidas con token - Validación y redirección automática */}
              <Route 
                path="/m/docs/:token" 
                element={
                  <MobileProtectedRoute>
                    <MobileDocumentsPage />
                  </MobileProtectedRoute>
                } 
              />
              <Route 
                path="/m/onboarding/:token" 
                element={
                  <MobileProtectedRoute>
                    <MobileOnboardingPage />
                  </MobileProtectedRoute>
                } 
              />
              <Route 
                path="/m/docs/:token/sales" 
                element={
                  <MobileProtectedRoute>
                    <MobileDocumentsPage />
                  </MobileProtectedRoute>
                } 
              />
              <Route 
                path="/m/onboarding/:token/flow" 
                element={
                  <MobileProtectedRoute>
                    <MobileCustomerFlowPage />
                  </MobileProtectedRoute>
                } 
              />
            </Route>
          </Routes>
        </Router>
      </div>
    </>
  );  
}

export default App;
